import { tw } from 'utils/classnames'

export function DownloadIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={tw('size-5', className)}
    >
      <path
        d="M13.8251 7.9165H12.5001V3.74984C12.5001 3.2915 12.1251 2.9165 11.6667 2.9165H8.33341C7.87508 2.9165 7.50008 3.2915 7.50008 3.74984V7.9165H6.17508C5.43341 7.9165 5.05841 8.8165 5.58341 9.3415L9.40841 13.1665C9.73341 13.4915 10.2584 13.4915 10.5834 13.1665L14.4084 9.3415C14.9334 8.8165 14.5667 7.9165 13.8251 7.9165ZM4.16675 16.2498C4.16675 16.7082 4.54175 17.0832 5.00008 17.0832H15.0001C15.4584 17.0832 15.8334 16.7082 15.8334 16.2498C15.8334 15.7915 15.4584 15.4165 15.0001 15.4165H5.00008C4.54175 15.4165 4.16675 15.7915 4.16675 16.2498Z"
        fill="currentColor"
      />
    </svg>
  )
}
